import { Box, Button, Card, CardBody, Flex, Spacer, Table, TableContainer, Tbody, Td, Text, Tr } from '@chakra-ui/react';

import { DeleteIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';
import { HiPaperAirplane } from 'react-icons/hi2';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import ModalLoading from '../../components/Loader/ModalLoader.jsx';
import { isEmptyObject } from '../../helper/utils/isEmptyObject.js';
import { urlNavigate } from '../../helper/utils/navigation.js';
import { convertDateFormat } from '../../helper/utils/utils.date.js';
import { doAddMinor, doDeleteMinor, doSubmission } from '../../redux/waiver/waiver.actions.js';
import FormLayoutProvider from '../layout/FormLayoutProvider.jsx';
import AddChildren from './AddChildren.jsx';

export default function FormWaiverChilds() {
    const { t } = useTranslation();

    const { data = {}, email = '', isSignWaiver = false, minor = [], loadingSubmission = false } = useSelector((s) => s?.waiver);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isContainNewMinor = () => minor.some((min) => min.isNew);

    const handleMinor = (val) => {
        const a = [...minor, { ...val, isNew: true }].map((el, idx) => ({ ...el, key: idx }));
        dispatch(doAddMinor(a));
    };

    const handleDelete = (el) => {
        console.log(el);
        const filter = minor.filter((ch) => ch?.key !== el?.key);
        dispatch(doDeleteMinor(filter));
    };

    const handleSubmit = () => {
        const minors = minor.map((el) => ({ ...el, parentId: data?.phone ?? '' }));

        const payload = {
            email: email === '' ? localStorage.getItem('email') : email,
            telp: data?.phone ?? '',
            birthDate: data?.birthDate ?? '',
            signature: '',
            fullName: data?.fullname ?? '',
            minor: minors,
        };

        localStorage.setItem('payload', JSON.stringify(payload));
        localStorage.setItem('minor', JSON.stringify(minors));

        if (isSignWaiver) {
            dispatch(doSubmission(payload, navigate));
        } else {
            navigate(urlNavigate('waiver', 'sign'), { replace: true });
        }
    };

    if (isEmptyObject(data)) {
        return <Navigate to={urlNavigate('online-sales', 'home')} />;
    }

    return (
        <>
            <ModalLoading loading={loadingSubmission} />

            <FormLayoutProvider>
                <Box my={4}>
                    <Text fontSize='2xl'>
                        <strong>{t('personal_data')}</strong>
                    </Text>
                </Box>
                <Card>
                    <CardBody>
                        <Box>
                            <TableContainer>
                                <Table variant='unstyled' size='sm'>
                                    <Tbody>
                                        <Tr>
                                            <Td>{t('full_name')}</Td>
                                            <Td textAlign='right'>
                                                <strong>{data?.fullname ?? ''}</strong>
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td>{t('email')}</Td>
                                            <Td textAlign='right'>
                                                <strong>{email}</strong>
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td>{t('telp')}</Td>
                                            <Td textAlign='right'>
                                                <strong>{data?.phone ?? ''}</strong>
                                            </Td>
                                        </Tr>
                                        <Tr>
                                            <Td>{t('birth_date')}</Td>
                                            <Td textAlign='right'>
                                                <strong>{convertDateFormat(data?.birthDate ?? '')}</strong>
                                            </Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </CardBody>
                </Card>
                <Box my={4}>
                    <Button mt={2} onClick={() => navigate(urlNavigate('waiver', 'user?isEdit=true'))} width='100%' variant='outline' colorScheme='primary'>
                        {t('edit')}
                    </Button>
                </Box>
                <Box>
                    <Box my={4}>
                        <Text fontSize='2xl'>
                            <strong>{t('any_under_18')}</strong>
                        </Text>
                    </Box>
                    <Box maxH='250px' overflow='scroll' scrollBehavior='smooth'>
                        {minor.map((el) => (
                            <>
                                <Card my={4} py={4} variant='outline'>
                                    <Box>
                                        <TableContainer>
                                            <Table variant='unstyled' size='sm'>
                                                <Tbody>
                                                    <Tr>
                                                        <Td>{t('full_name')}</Td>
                                                        <Td textAlign='right'>
                                                            <strong>{el?.name ?? ''}</strong>
                                                        </Td>
                                                    </Tr>
                                                    <Tr>
                                                        <Td>{t('birth_date')}</Td>
                                                        <Td textAlign='right'>
                                                            <strong>{convertDateFormat(el?.birthDate ?? '')}</strong>
                                                        </Td>
                                                    </Tr>
                                                </Tbody>
                                            </Table>
                                        </TableContainer>
                                        <Spacer />
                                        {el?.isNew ? (
                                            <Box mx={4}>
                                                <Flex w='full' alignItems='center' justifyContent='end' mt={1}>
                                                    <Button width='max-content' size='sm' onClick={() => handleDelete(el)} colorScheme='red' aria-label='Delete' leftIcon={<DeleteIcon />}>
                                                        {t('remove')}
                                                    </Button>
                                                </Flex>
                                            </Box>
                                        ) : null}
                                    </Box>
                                </Card>
                            </>
                        ))}
                    </Box>
                </Box>
                <AddChildren handleMinor={handleMinor} />
                <Box my={2}>
                    <Button py={7} onClick={handleSubmit} colorScheme='red' width='100%' rightIcon={<HiPaperAirplane />}>
                        {isContainNewMinor() ? 'Regist New Minor' : t('next')}
                    </Button>
                </Box>
            </FormLayoutProvider>
        </>
    );
}
